import React from 'react';
import { Trans } from '@lingui/macro';
import { Link } from 'dva/router';
import acs from '@mos-utils/acs';
import { useAuthorizationStatus } from '@mos-utils/acs-react';
import { Button } from '@mos-cat/typography';
import './Lead.pcss';
import { sendStats, START_CLICK } from '../../../helpers/stats';

const Lead = (): JSX.Element => {
  const value = useAuthorizationStatus();

  const loginButton =
    value === 'authorized' ? (
      <Link
        className="mos-button mos-button_type_primary Lead__action-button"
        to="/new/"
        onClick={() => sendStats(START_CLICK)}
      >
        <Trans>Подать заявление</Trans>
      </Link>
    ) : (
      <Button
        className="mos-button mos-button_type_primary Lead__action-button"
        primary
        onClick={() => {
          sendStats(START_CLICK);
          acs.login(`${window.location.href}new`);
        }}
      >
        <Trans>Подать заявление</Trans>
      </Button>
    );

  return (
    <div className="Lead">
      <div className="Lead__wrapper">
        <h1 className="Lead__title">
          <Trans> Получение и продление статуса многодетной семьи </Trans>
        </h1>
        <div className="Lead__content">
          <Trans>
            Данная услуга позволяет подать заявление на присвоение или продление
            статуса многодетной семьи города Москвы в электронном виде.
          </Trans>
        </div>
        <div className="Lead__action">{loginButton}</div>
      </div>
    </div>
  );
};

export default Lead;
